import {
  isActiveBackgroundTask,
  isReachDraftTask,
  reachDraftScope,
  type BackgroundTask,
} from "./background-tasks";

/** 成稿中指示器：必须有 plan_step_id，且只匹配该步 */
export function isStepDrafting(
  tasks: BackgroundTask[],
  opts: { planStepId: number | null; externalUserid?: string | null },
): boolean {
  if (opts.planStepId == null) return false;

  return tasks.some((task) => {
    if (!isReachDraftTask(task) || !isActiveBackgroundTask(task)) return false;
    const scope = reachDraftScope(task);
    if (scope.planStepId !== opts.planStepId) return false;
    if (opts.externalUserid && scope.externalUserid && scope.externalUserid !== opts.externalUserid) {
      return false;
    }
    return true;
  });
}

/** 同客户是否已有进行中的成稿（其它步应禁用） */
export function contactHasActiveReachDraft(
  tasks: BackgroundTask[],
  externalUserid: string,
): boolean {
  return tasks.some((task) => {
    if (!isReachDraftTask(task) || !isActiveBackgroundTask(task)) return false;
    return reachDraftScope(task).externalUserid === externalUserid;
  });
}
